// extracted by mini-css-extract-plugin
export default {"heading":"FederationEventsPage_heading__ZbyPD","pagination":"FederationEventsPage_pagination__x-R7S","headingContainer":"FederationEventsPage_headingContainer__cgasz"};